import mdcTabBar from './mdc-tab-bar.vue'
import mdcTab from './mdc-tab.vue'
import mdcTabIndicator from './mdc-tab-indicator.vue'
export const mdcTabComponents = {
  mdcTabBar,
  mdcTab,
  mdcTabIndicator,
}